export const checkPhoneNumberValidation = (phoneNumber: string) => {
  //   ^는 문자열의 시작을 의미합니다.
  // \+?는 +가 0번 또는 1번 올 수 있음을 의미합니다.
  // [0-9]{1,3}는 숫자가 1번에서 3번 올 수 있음을 의미합니다.
  // -?는 하이픈이 0번 또는 1번 올 수 있음을 의미합니다.
  // [0-9]{1,4}는 숫자가 1번에서 4번 올 수 있음을 의미합니다. 이 패턴을 3번 반복하여 총 14자리 이하의 숫자를 포함합니다.
  // $는 문자열의 끝을 의미합니다.
  const phoneRegex = /^\+?[0-9]{1,3}-?[0-9]{1,4}-?[0-9]{1,4}-?[0-9]{1,4}$/

  // 정규 표현식에 따라 유효성 검사
  return phoneRegex.test(phoneNumber)
}
